import { api } from "@/lib/axios"
import type {
  PersonalExpensesResponse,
  CreatePersonalExpensePayload,
  CreatePersonalExpenseResponse,
  PersonalExpenseDetailResponse,
  UpdatePersonalExpensePayload,
  DeletePersonalExpenseResponse,
} from "@/types/personal-expenses"

export async function fetchPersonalExpenses(): Promise<PersonalExpensesResponse> {
  const { data } = await api.get<PersonalExpensesResponse>(
    "/admin/personal-expenses/"
  )
  return data
}

export async function createPersonalExpense(
  payload: CreatePersonalExpensePayload
): Promise<CreatePersonalExpenseResponse> {
  const { data } = await api.post<CreatePersonalExpenseResponse>(
    "/admin/personal-expenses/",
    payload
  )
  return data
}

export async function fetchPersonalExpenseDetail(
  id: number
): Promise<PersonalExpenseDetailResponse> {
  const { data } = await api.get<PersonalExpenseDetailResponse>(
    `/admin/expenses/${id}/`
  )
  return data
}

export async function updatePersonalExpense(
  id: number,
  payload: UpdatePersonalExpensePayload
): Promise<PersonalExpenseDetailResponse> {
  const { data } = await api.patch<PersonalExpenseDetailResponse>(
    `/admin/expenses/${id}/`,
    payload
  )
  return data
}

export async function deletePersonalExpense(
  id: number
): Promise<DeletePersonalExpenseResponse> {
  const { data } = await api.delete<DeletePersonalExpenseResponse>(
    `/admin/expenses/${id}/`
  )
  return data
}
